import $ from 'jquery'

export default class DesktopNav {
    constructor($el) {
        this.$el = $el

        this.$searchToggle = $('.search-toggle a')
        this.$searchField = $('.st-default-search-input')
        const calcFlyouts = this.calcFlyouts

        this.$searchToggle.on('click', (e) => {
            e.preventDefault();
            this.toggleSearch()
        })
        $('body').on('mousedown', (e) => {
            this.hide_search(e)
        })
        $(() => {
            calcFlyouts();
        });
        $(window).on('resize', function () {
            calcFlyouts()
        })
    }
    calcFlyouts() {
        $('.flyout').each(function () {
            $(this).css('--flyoutWidth', $(this).outerWidth() + 'px')
        })
        $('.flyouts > li').each(function () {
            $(this).css('--leftEdgeMenuParent', this.offsetLeft + 'px')
        })
    }
    toggleSearch() {
        $('.search-container').toggleClass('active')
    }
    hide_search(e) {
        let element = $(e.target)
        if (!element.is('.search-container') && element.parents('.search-container').length == 0) {
            $('.search-container').removeClass('active')
        }
    }
}
